import React, { useContext, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  Box,
  Flex,
  Switch,
  Textarea,
  Spinner,
} from "@chakra-ui/react";
import { FiUserCheck } from "react-icons/fi";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";

interface RejectModalProps {
  isOpen: boolean;
  close: () => void;
  data: any;
  getAllData?: any;
}

const RejectDocumentModal: React.FC<RejectModalProps> = ({
  isOpen,
  close,
  data,
  getAllData,
}) => {
  const {toastNotify} = useContext(AppContext)
  const [isRejected, setIsRejected] = useState(false);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!isRejected) return alert("Enable rejection switch");
    if (!comment.trim()) return alert("Comment is required");

    setLoading(true);
    try {
      const response : any = await appRequest("document", "rejectDuplicateDocument", {
        document: data?._id,
        status: "rejected",
        comment,
      });
      if (response?.status === "success") {
        toastNotify({
          title: "Updated Successfully",
          message: response?.message,
          type: "success",
        });
        getAllData && getAllData();
        close();
      }
      else{
        toastNotify({
          title : 'Failed to Update',
          message :response?.message,
          type:'error'
        })
      }
    }
    catch(err : any){
      toastNotify({
          title : 'Failed to Update',
          message :err?.message,
          type:'error'
        })
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={close} size="md" isCentered>
      <ModalOverlay backdropFilter="blur(3px)" />
      <ModalContent borderRadius="xl">
        <Box
          bg="red.500"
          color="white"
          p={5}
          display="flex"
          alignItems="center"
          gap={3}
        >
          <FiUserCheck size={24} />
          <ModalHeader m={0} p={0} fontSize="xl" fontWeight="bold">
            Reject Document
          </ModalHeader>
        </Box>

        <ModalCloseButton color="white" />

        <ModalBody p={6}>
          {/* Document info */}
          <Box bg="white" p={4} borderRadius="lg" border="1px solid #eee" mb={6}>
            <Text fontWeight="600" fontSize="lg" color="gray.800">
              {data?.originalValues?.Vendor_Name}
            </Text>
            <Text fontSize="sm" color="gray.600">
              {data?.name}
            </Text>
          </Box>

          {/* ONLY TWO FIELDS BELOW */}

          {/* 1️⃣ Reject Switch */}
          <Flex align="center" justify="space-between" mb={4}>
            <Text fontWeight="600" fontSize="md">
              Mark as Rejected
            </Text>
            <Switch
              size="lg"
              colorScheme="red"
              isChecked={isRejected}
              onChange={(e) => setIsRejected(e.target.checked)}
            />
          </Flex>

          {/* 2️⃣ Comment */}
          <Textarea
            placeholder="Enter rejection comment..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows={3}
            borderColor="red.300"
            focusBorderColor="red.500"
            isDisabled={!isRejected}
          />
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={close} disabled={loading}>
            Cancel
          </Button>

          <Button
            colorScheme="red"
            onClick={handleSubmit}
            disabled={loading || !isRejected || !comment.trim()}
          >
            {loading ? <Spinner size="sm" /> : "Reject"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RejectDocumentModal;
